import { useQuasar } from 'quasar'
import { computed, ref } from 'vue'
import type { InfoBoxEmits, InfoBoxProps } from '../types'
import { useInfoBoxGroup } from './useInfoBoxGroup'

export function useInfoBoxState(props: InfoBoxProps, emit: InfoBoxEmits) {
  const $q = useQuasar()
  const copied = ref(false)
  const isClipboardSupported = ref(true)
  const internalExpanded = ref(props.defaultExpanded)
  const { notifyExpand, clearActive } = useInfoBoxGroup()

  const isCopyEnabled = computed(() => {
    if (props.copyable !== null) {
      return props.copyable
    }
    return !!props.copyValue
  })

  const isDark = computed(() => $q.dark.isActive)

  const theme = computed(() => {
    return props.theme || 'default'
  })

  const collapseThisInstance = () => {
    if (!cExpanded.value) {
      return
    }

    if (props.modelValue !== undefined) {
      emit('update:model-value', false)
      emit('update:expanded', false)
    } else {
      internalExpanded.value = false
      emit('update:expanded', false)
    }

    if (props.group) {
      clearActive(props.group, thisInstance)
    }
  }

  const thisInstance = { collapse: collapseThisInstance }

  const cExpanded = computed({
    get: () => {
      const val = props.modelValue !== undefined ? !!props.modelValue : internalExpanded.value
      return val
    },
    set: (value: boolean) => {
      const oldValue = cExpanded.value

      if (value === oldValue) {
        return
      }

      if (props.modelValue !== undefined) {
        emit('update:model-value', value)
        emit('update:expanded', value)
      } else {
        internalExpanded.value = value
        emit('update:expanded', value)
      }

      if (props.group) {
        if (value) {
          notifyExpand(props.group, thisInstance)
        } else {
          clearActive(props.group, thisInstance)
        }
      }
    },
  })

  return {
    copied,
    isClipboardSupported,
    internalExpanded,
    isCopyEnabled,
    isDark,
    theme,
    cExpanded,
    thisInstance,
    collapseThisInstance,
  }
}
